import { render, staticRenderFns } from "./SchoolClassExams.vue?vue&type=template&id=2ed000c7"
import script from "./SchoolClassExams.vue?vue&type=script&lang=js"
export * from "./SchoolClassExams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports